import React from 'react';

interface OutlineLeftArrowProps {
    fill?: string;
}

export const OutlineLeftArrow = ({ fill = 'currentColor' }: OutlineLeftArrowProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.96448 0.70707L7.90398 5.64657C7.99534 5.74158 8.04637 5.86827 8.04637 6.00007C8.04637 6.13188 7.99534 6.25856 7.90398 6.35357L2.96698 11.2901L3.67398 11.9971L8.61098 7.06057C8.88349 6.77465 9.0355 6.39481 9.0355 5.99982C9.0355 5.60483 8.88349 5.225 8.61098 4.93907L3.67148 7.01881e-05L2.96448 0.70707Z"
            fill={fill}
        />
    </svg>
);
